module.exports = __webpack_public_path__ + "static/media/Team 1 - Novus.f5f3c237.jpeg";